import React from 'react';
import clsx from 'clsx';

import './styles.scss';

export default function QueryReadout({ url, modifier, children }) {
  return (
    <div className={clsx('query-readout', modifier && `query-readout--${modifier}`)}>
      {children}
      {url && (
        <a href={url} target="_blank" aria-label="View full data explorer for this query"></a>
      )}
    </div>
  );
}

export function PoliciesQueryReadout({ policyType, branchPolicyType, year, url }) {
  const type = policyType.model.id ? policyType.model.name : 'All';

  return (
    <QueryReadout url={url} modifier="policies">
      <em>{type} </em>
      <span>policies </span>
      <span>active in </span>
      <em>{year.model.name.toString().toLowerCase()} </em>
    </QueryReadout>
  );
}

export function TradeQueryReadout({ query, url }) {
  const units = query.units === 'value' ? 'value (US $)' : 'weight';

  return (
    <QueryReadout url={url} modifier="trade">
      <em>{query.exporter.model.name} </em>
      <span>exporting </span>
      <em>{query.category.model.name} </em>
      <span>to </span>
      <em>{query.importer.model.name}</em>
      <span>, </span>
      <span> in </span>
      <em>{query.year.id} </em>
      <span>by </span>
      <em>{units}</em>
    </QueryReadout>
  );
}
